import PropTypes from 'prop-types';
import React from 'react';
import SubmitButton from '../../molecules/SubmitButton';

const GoToMobile = ({match}) => (
    <section className="go-to-app-container">
        <div className="go-to-app-spinner">
            <div />
            <div />
            <div />
            <div />
        </div>
        <p>Processing...</p>
        <a href={`worldremit.xt://payment?info=${match.params.statusName}`}>
            <SubmitButton showChevron={false}>Go to app</SubmitButton>
        </a>
    </section>
);

GoToMobile.getServerSideProps = async () => {};

GoToMobile.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            statusName: PropTypes.string.isRequired
        }).isRequired
    }).isRequired
};

export default GoToMobile;
